import { NormalizedEntityItem } from '@/lib/edlink-utils';
import { ChevronDown, ChevronLeft } from 'lucide-react';
import { useState } from 'react';
import { SummaryItemList } from './summary-item-list';

interface ExpandableSummarySectionProps {
  label: string;
  color: string;
  items?: NormalizedEntityItem[];
}

export function ExpandableSummarySection({ label, color, items = [] }: ExpandableSummarySectionProps) {
  const [expanded, setExpanded] = useState(false);
  const hasItems = items.length > 0;

  return (
    <div className={`border-l-4 ${color} bg-gray-100`}>
      <button
        type="button"
        className="flex w-full items-center justify-between pl-3 py-1 text-sm font-medium"
        onClick={() => setExpanded((val) => !val)}
        disabled={!hasItems}
      >
        <span>
          {label}: {items.length}
        </span>
        {hasItems && (expanded ? <ChevronDown className="h-4 w-4 mr-2" /> : <ChevronLeft className="h-4 w-4 mr-2" />)}
      </button>
      {expanded && hasItems && <SummaryItemList items={items} />}
    </div>
  );
}
